import { Link } from 'react-router-dom';
import { ModelScene, CreateScene, EntityScene, UpdateScene, DeleteScene, IndexScene } from 'components';
import { Nav } from './Nav';
import { Form } from './Form';
import { OneCIntegration } from './OneCIntegration';
import { Membership } from './Membership';
import { MembershipLog } from './MembershipLog';
import { PlanningConfig } from './PlanningConfig';
import { Logos } from './Logos';
import { bool } from 'components/columns';
import type { Enterprise } from 'modules/core/types';
import { TableColumns } from '@ff-it/ui';

const columns: TableColumns<Enterprise> = [
  {
    content: 'Company',
    key: 'company',
    render: ({ id, company: { title } }: Enterprise) => <Link to={`${id}`}>{title}</Link>,
  },
  {
    content: 'Slug',
    key: 'slug',
  },
  bool('External', 'external'),
];

const initialValues = {
  company: null,
  external: false,
  invoice_sequence: {
    format: '',
    reset_period: null,
  },
  acceptance_sequence: {
    format: '',
    reset_period: null,
  },
  client_agreement_sequence: {
    format: '',
    reset_period: null,
  },
  vat_strategy: null,
  campaign_block_format: '{campaign}/#',
  campaign_sequence: null,
  direct_agreements: false,
  horizon_synchronization_strategy: 'default',
};

function mapValues(v: any): any {
  if (v.external) {
    const { company, slug, external } = v;
    return { company, slug, external };
  }
  return v;
}

const model = {
  endpoint: 'core/enterprises/',
  title: 'Agency',
  pluralTitle: 'Agencies',
  entityTitle: ({ company: { title } }: Enterprise) => title,
  permissions: undefined,
};
export const route = {
  path: 'agencies',
  element: <ModelScene {...model} />,
  children: [
    { index: true, element: <IndexScene columns={columns} /> },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues} mapValues={mapValues}>
          <Form />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: (
        <EntityScene>
          <Nav />
        </EntityScene>
      ),
      children: [
        {
          index: true,
          element: (
            <UpdateScene heading={null} mapValues={mapValues}>
              <Form />
            </UpdateScene>
          ),
        },
        {
          path: 'logos',
          element: <Logos />,
        },
        {
          path: 'planning',
          element: <PlanningConfig />,
        },
        {
          path: 'membership/*',
          element: <Membership />,
        },
        {
          path: 'membership_log/',
          element: <MembershipLog />,
        },
        {
          path: 'onec/*',
          element: <OneCIntegration />,
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ],
};
